import React, { useMemo, useState } from 'react';

const useAggFuncOptions = ({
  fieldAndAggFunc,
  setFieldAndAggFunc,
}: {
  fieldAndAggFunc: { field: string; aggFunc: AggFunc };
  setFieldAndAggFunc: React.Dispatch<
    React.SetStateAction<{ field: string; aggFunc: AggFunc }>
  >;
}) => {
  const [acceptedAggFuncs, setAcceptedAggFuncs] = useState<AggFunc[]>([
    'count',
    'count_first_day',
    'count_last_day',
    'count_per_day',
    'count_per_week',
    'first',
    'last',
  ]);
  const aggFuncOptions = useMemo((): DropdownOption[] => {
    return acceptedAggFuncs.map((func) => ({
      label: func,
      isSelected: fieldAndAggFunc.aggFunc === func,
      onSelected: () => {
        setFieldAndAggFunc((c) => ({ ...c, aggFunc: func }));
      },
    }));
  }, [acceptedAggFuncs, fieldAndAggFunc.aggFunc, setFieldAndAggFunc]);

  return {
    aggFuncOptions,
    setAcceptedAggFuncs,
  };
};

export default useAggFuncOptions;
